var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"emission_reduce_page"},[_c('dec-block-title',[_vm._v("减排累计TOP5(t)")]),_c('dv-charts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }